import { NextPage } from 'next'
import AboutUsScreen from '../screens/AboutUs'
import AppAboutUsScreen from '../screens/App-AboutUs'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const AboutUs: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<AboutUsScreen />) : (<AppAboutUsScreen />)}
        </>
    )
}